var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment_help"},[_c('titleBar',{attrs:{"title":_vm.title}}),_c('benefit',{staticClass:"hook",attrs:{"benefit-content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }